import React, { useState } from 'react';
import { useFloatMessage, MESSAGE_TYPE } from './../../../Providers/FloatMessage';
import { DisqualifyParticipant } from '../../../../utilities/BL/Xtp';

export const XtpDisqualifyModal = ({ isOpen, participant, onClose, onDisqualified }) => {
    const { showMessage } = useFloatMessage();
    const [reason, setReason] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isOpen || !participant) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!reason || reason.trim().length < 5) {
            showMessage({
                message: 'Por favor ingresa un motivo detallado (mínimo 5 caracteres).',
                type: MESSAGE_TYPE.WARNING
            });
            return;
        }

        setIsSubmitting(true);
        try {
            const operatorName = 'Staff Admin Interaktia';
            const res = await DisqualifyParticipant(participant.id, reason.trim(), operatorName);
            if (res && res.success) {
                showMessage({
                    message: `Participante ${participant.name} descalificado exitosamente. Su pase ha sido anulado.`,
                    type: MESSAGE_TYPE.SUCCESS
                });
                if (onDisqualified) onDisqualified(participant.id);
                onClose();
            } else {
                showMessage({
                    message: res?.message || 'Error al descalificar al participante.',
                    type: MESSAGE_TYPE.ERROR
                });
            }
        } catch (err) {
            console.error('Error al descalificar:', err);
            showMessage({
                message: 'Error de conexión al procesar la descalificación.',
                type: MESSAGE_TYPE.ERROR
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1070 }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
                    <div className="modal-header bg-danger text-white px-4 py-3">
                        <div className="d-flex align-items-center gap-2">
                            <i className="bi bi-shield-slash-fill fs-5"></i>
                            <h5 className="modal-title fw-bold text-white mb-0">
                                Descalificar Participante
                            </h5>
                        </div>
                        <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={isSubmitting}></button>
                    </div>

                    <form onSubmit={handleSubmit} className="modal-body p-4 bg-light">
                        <div className="alert alert-warning border-0 small d-flex gap-2 align-items-start mb-3">
                            <i className="bi bi-exclamation-triangle-fill fs-5 text-warning"></i>
                            <div>
                                <strong>Acción Relevante:</strong> Al descalificar a este aficionado, su código QR quedará marcado como <strong className="text-danger">INVALIDADO</strong> en tiempo real impidiendo su canje en tiendas oficiales o estadio.
                            </div>
                        </div>

                        <div className="bg-white p-3 rounded-3 border mb-3">
                            <div className="small text-secondary mb-1">Detalles del Aficionado:</div>
                            <div className="fw-bold fs-6 text-dark">{participant.name}</div>
                            <div className="small text-secondary">
                                Folio Pase: <strong className="text-dark">{participant.passCode}</strong> | Medalla: <strong className="text-dark">{participant.medalCode}</strong>
                            </div>
                            <div className="small text-secondary">
                                Ticket: <strong className="text-dark">{participant.ticketNumber}</strong> | Correo: <strong className="text-dark">{participant.email}</strong>
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-bold small text-dark">
                                Motivo de Descalificación <span className="text-danger">*</span>
                            </label>
                            <textarea
                                className="form-control"
                                rows="3"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                placeholder="Ej. Ticket duplicado/falsificado, código de medalla ajeno no coincidente con comprobante de compra..."
                                required
                            ></textarea>
                            <div className="form-text small">
                                Este motivo quedará registrado en auditoría y en el reporte oficial Excel.
                            </div>
                        </div>

                        <div className="modal-footer px-0 pb-0 pt-2 border-top">
                            <button type="button" className="btn btn-secondary px-3 fw-semibold" onClick={onClose} disabled={isSubmitting}>
                                Cancelar
                            </button>
                            <button type="submit" className="btn btn-danger px-4 fw-bold d-flex align-items-center gap-2" disabled={isSubmitting}>
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status"></span>
                                        Descalificando...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-slash-circle-fill"></i>
                                        Confirmar Descalificación
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};
